import { Navigate, useLocation } from "react-router-dom";
import type { PropsWithChildren } from "react";
import { useAuth } from "../lib/auth";
import { Logo } from "./Logo";

export function ProtectedRoute({ children }: PropsWithChildren) {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <main className="app-loading" aria-busy="true" aria-label="Carregando Calcme 3D">
        <Logo />
        <div className="loading-bar"><span /></div>
      </main>
    );
  }
  if (!session) {
    return <Navigate to="/auth" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
}
